import { omniContractScopeOfWorkAddDialogConfig } from "@/services/backend/omni/servicekindrules/omni-contract-scope-of-work-add-dialog-config";
import { useParams } from "react-router";
import { useOmniContractShowQuery } from "@/services/backend/omni/contract/api/contract-api";
import { ContractScopeOfWorksPage } from "@/services/backend/omni/contract/components/contract-scope-of-works-page";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function ContractScopeOfWorksRoute() {
  const { contractId } = useParams();

  const { data, isLoading, error } = useOmniContractShowQuery({
    id: contractId!,
  });

  return (
    <div>
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
      {data && (
        <ContractScopeOfWorksPage
          contract={data}
          addDialogConfig={omniContractScopeOfWorkAddDialogConfig}
        />
      )}
    </div>
  );
}
